<template>
    <component
        :is="view"
        :isRegist="isRegist"
        :menuList="menuList"
        :applications="applications"
        :unreadMessageNum="unreadMessageNum"
        :currentUser="currentUser"
        :showManage="showManage"
        :showPersonCenter="showPersonCenter"
        :showStrain="showStrain"
        :brandInfo="brandInfo"
        @change-menu="changeMenu"
        :active-route="checkedRoute"
        :navTemplateId="navTemplateId"
        isSelfLoginFunc
        isSelfExitFunc
        :showSwitchOtherInst="showSiteList"
        :personalInList="personalInstitutions"
        :manageUrl="manageUrl"
        @login="login"
        @exit="exit"
    ></component>
</template>

<script setup>
import WorkbenchHeader from '@/components/menu/workbench-header.vue';
import HomeHeaderMenu from './part/home-header-menu.vue';
import CommonMainHeaderMenu from './part/common-main-header-menu.vue';
import {ref, computed, watch, inject, nextTick, onMounted, onBeforeUnmount } from 'vue';
import {pageJump} from '@/global/location-transfer';
import {useStore} from 'vuex';
import {useRoute} from 'vue-router';
import {staticRoutes} from '@/router';
import {XCMainHeader} from '@yanxiu/header';

// 站点配置

const moocComName = inject('moocComName');

const store = useStore();
const route = useRoute();

const props = defineProps({
    curTab: {
        // 菜单
        type: String,
        default: 'home'
    }
});

const componentMap = {
    home: HomeHeaderMenu, // 首页导航
    main: XCMainHeader, // 二级页导航
    'common-main': CommonMainHeaderMenu, // 二级页导航
    'workbench': WorkbenchHeader,
};
const view = computed(() => {
    if (props.curTab === 'main') {
        const pagePermission = store.state?.pagePermission || {};
        const templateInfo = pagePermission['personalCenter:page:template']?.moduleRuleList || [];
        if (templateInfo.length) {
            const item = templateInfo.find(item => item.ruleKey === 'new');
            if (item) {
                return item.checked ? WorkbenchHeader : XCMainHeader
            }
        }
        return XCMainHeader;
    }

    return componentMap[props.curTab];
})

//  ---------- 头部npm 包 配置
const applications = ref([]);
// 获取是否登录
const registMap = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let list =
        pagePermission['accountManage:loginAndRegist:isOpen']?.moduleRuleList ||
        [];
    let temp = {};
    list?.length &&
        list.forEach(element => {
            temp[element.ruleKey] = element.checked;
        });
    return temp;
});

const pagePermission = computed(() => {
    return store.state?.pagePermission || {};
});

const comName = computed(() => {
    return pagePermission.value?.coopgroup?.moduleNameAlias || pagePermission.value?.coopgroup?.moduleName || '协作组';
});

const isRegist = computed(() => {
    return !registMap.value?.['0'];
});

const isHaveSmc = computed(() => { // 新管理中心包含科研
    return store.state.user?.isHaveSmc;
})

const manageUrl = computed(() => {
    return isHaveSmc.value ? 'smc.index': 'idxmc.index'
})

// 是否显示管理中心
const showManage = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let isHaveIdmx = store.state.user?.isHaveIdmx; // 旧管理中心
    return !!pagePermission['manageCenter:base:home'] && (isHaveIdmx || isHaveSmc.value);
});
// 是否显示个人中心
const showPersonCenter = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['personalCenter:page'];
});
// 是否显示培训管理系统
const showStrain = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let isHaveStrain = store.state.user?.isHaveStrain;
    return (
        !!pagePermission.continuingEducation &&
        !!pagePermission.train &&
        isHaveStrain
    );
});
// 全部备案信息
const brand = computed(() => {
    // console.log('brand====', JSON.stringify(store.state.brand))
    return store.state.brand?.publishBrand || {};
});

// 具体备案信息
const brandInfo = computed(() => {
    // console.log('brandInfo====', JSON.stringify(brand.value?.brandConfig))
    return brand.value?.brandConfig || {};
});

// 获取用户当前信息

const currentUser = ref({});

const navTemplateId = computed(() => {
    return store.state.user?.navTemplateId || '';
});
const isHideLogo = computed(() => store.state?.pagePermission?.['portal:navigation:hideLogo'] || '');
// 是否展示用户站点信息, 切换站点
const showSiteList = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let list = pagePermission.switchOtherInst?.moduleRuleList || []
    let res = list.find(item => !!item.checked) || {};
    return res.ruleKey === 'yes';
})

// 站点列表
const personalInstitutions = computed(() => {
    return store.state.user?.personalInstitutions || [];
})


// 监听个人信息变化
watch(
    () => store.state.currentUser,
    val => {
        currentUser.value = val;
        if (val.userId) {
            store.dispatch('user/getUnreadMessage');
            getApplicationList();
        }
    },
    {deep: true, immediate: true}
);

// 获取应用
function getApplicationList() {
    G_transmit('getUserCenterLatestBrand', {
        name: 'getUserCenterLatestBrand'
    })
        .then(res => {
            const data = res?.data || [];
            let menuList = [];
            let tempMap = {};
            data.length &&
                data.forEach(item => {
                    if (
                        item.moduleKey &&
                        staticRoutes[item.moduleKey] &&
                        staticRoutes[item.moduleKey].name &&
                        !tempMap[item.moduleKey]
                    ) {
                        tempMap[item.moduleKey] = item;
                        let title = staticRoutes[item.moduleKey].title;
                        let shortTitle = staticRoutes[item.moduleKey].meta?.shortTitle;
                        if (item.moduleKey === 'coopgroup:my') {
                            title = comName.value;
                            shortTitle = comName.value;
                        } else if (item.moduleKey === 'moocApplication:my') {
                            title = moocComName;
                            shortTitle = moocComName;
                        }
                        let temp = {
                            path: staticRoutes[item.moduleKey].path,
                            id: item.moduleKey,
                            title,
                            shortTitle,
                            route: {name: staticRoutes[item.moduleKey].name},
                            isOther: false,
                            icon: images[item.moduleKey]
                        };
                        menuList.push(temp);
                    }
                });
            applications.value = menuList || [];
        })
        .catch(() => {});
}


const images = {
    'resourceApplication:my': require('@/assets/img/menu-icon/resource.png'),
    'coopgroup:my': require('@/assets/img/menu-icon/group.png'),
    'activity:my': require('@/assets/img/menu-icon/activity.png'),
    'train:my': require('@/assets/img/menu-icon/course.png'),
    'continuingEducation:my': require('@/assets/img/menu-icon/teach.png'),
    'video:my': require('@/assets/img/menu-icon/case.png'),
    'moocApplication:my': require('@/assets/img/menu-icon/mooc.png'),
    'material:my': require('@/assets/img/menu-icon/material.png'),
    'workshop:my': require('@/assets/img/menu-icon/studio.png'),
    'competition:my': require('@/assets/img/menu-icon/competition.png'),
    'research:my': require('@/assets/img/menu-icon/research.png'),
    'selection:my': require('@/assets/img/menu-icon/competition.png'),
    'expertstudio:my': require('@/assets/img/menu-icon/studio2.png'),
    'basicschool:my': require('@/assets/img/menu-icon/school.png'),
    'project:my': require('@/assets/img/menu-icon/subject.png'),
    'resultcultivation:my': require('@/assets/img/menu-icon/achievement.png'),
    'resultselection:my': require('@/assets/img/menu-icon/achievement-awards.png')
    // 'courseResource:my': require('@/assets/img/menu-icon/course-resource.png'),
    // 'continueEducation:my': require('@/assets/img/menu-icon/credit-space.png'),
};

// 获取消息数量
const unreadMessageNum = computed(() => {
    let num =
        store.state?.unreadMessage?.like + store.state?.unreadMessage?.message;
    if (+num == 0) {
        num = false;
    }
    if (+num > 99) {
        num = '99+';
    }
    return num;
});

const menuList = computed(() => {
    let list = store.getters['user/userMenus'] || [];
    return list.filter(item => {
        return item?.path || (item?.sub_navs && item?.sub_navs.length);
    });
});

// 高亮路由
const activePath = computed(() => {
    return route.path;
});

// 高亮路由
const checkedRoute = computed(() => {
    const curRoute =
        menuList.value.find(item => {
            if (getActive(item)) {
                return true;
            }
            return false;
        }) || {};
    return curRoute;
});

// 一级导航选中状态
function getActive(menuItem) {
    if (menuItem?.path && menuItem.path.indexOf(activePath.value) > -1) {
        return true;
    }
    if (menuItem?.sub_navs && menuItem?.sub_navs.length) {
        //
        let curItem = menuItem?.sub_navs?.find(subItem => {
            return (
                subItem?.path && subItem?.path.indexOf(activePath.value) > -1
            );
        });
        return !!curItem;
    }
    return false;
}

// 点击导航
async function changeMenu(menuItem) {
    if (menuItem?.sub_navs && menuItem?.sub_navs.length) {
        return;
    }
    if(menuItem.indexOf('/api/thirdlogin/fastLogin') > -1) {
        try {
            let res = await G_transmit('getOtherAiToken', {});
            let data = res.data || {};
            let url = menuItem + `?token=${data.token}&encryptedToken=${data.encryptedToken}`;
            pageJump(url);
        }catch(err) {
            
        }
    }else {
        pageJump(menuItem);
    }
}

function login () {
    console.log('logout', 444)
    store.dispatch('logout');
}

function exit() {
    store.dispatch('logoutHome');
}
// 监听路由变化
watch(() => route.path, () => {
    nextTick(() => {
        if (isHideLogo.value) {
            // 获取元素
            const dom = document.querySelector('.header-container .left-wrap .pointer');
            if (dom) {
                const has = dom.classList.contains('hide-logo'); // 布尔值
                if (!has) {
                    dom.classList.add('hide-logo');
                }
            }
        }
    });
}, {
    immediate: true,
});
onMounted(() => {
    setTimeout(() => {
        if (isHideLogo.value) {
            const dom = document.querySelector('.header-container .left-wrap .pointer');
            if (dom) {
                const has = dom.classList.contains('hide-logo'); // 布尔值
                if (!has) {
                    dom.classList.add('hide-logo');
                }
            }
        }
    }, 300);
});
onBeforeUnmount(() => {
    const dom = document.querySelector('.header-container .left-wrap .pointer');
    if (dom) {
        const has = dom.classList.contains('hide-logo'); // 布尔值
        if (has) {
            dom.classList.remove('hide-logo');
        }
    }
});
</script>

<style lang="scss">
.hide-logo{
    display:none !important;
}
</style>
